import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';

import Navbar from './components/layout/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/layout/Footer';

import Home from './pages/Home';
import Services from './pages/Services';
import CaseStudies from './pages/CaseStudies';
import About from './pages/About';
import Contact from './pages/Contact';
import CaseStudyDetail from './pages/CaseStudyDetail';
import ServiceDetail from './pages/ServiceDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Pricing from './pages/Pricing';
import Insights from './pages/Insights';
import InsightDetail from './pages/InsightDetail';
import NotFound from './pages/NotFound';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightDetail />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            {/* Legacy redirects */}
            <Route path="/portfolio" element={<Navigate to="/case-studies" replace />} />
            <Route path="/ai" element={<Navigate to="/services/ai-automation" replace />} />
            <Route path="/services/web-app-development" element={<Navigate to="/services/custom-software" replace />} />
            <Route path="/services/mobile-apps" element={<Navigate to="/services/custom-software" replace />} />
            <Route path="/services/ui-ux-design" element={<Navigate to="/services/custom-software" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
